import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';

import { RootState } from 'state/store';

const Alert = (props: AlertProps) => <MuiAlert elevation={6} variant="filled" {...props} />;

const Notification = () => {
  const notification = useSelector((state: RootState) => state.app.notification);
  const [showNotification, setShowNotification] = useState(false);

  // auto-hide any non-error notifications
  const autoHideDuration = notification?.type === 'error' ? null : 5000;

  useEffect(() => {
    if (notification) {
      setShowNotification(true);
    }
  }, [notification]);

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setShowNotification(false);
  };

  return (
    <Snackbar open={showNotification} autoHideDuration={autoHideDuration} onClose={handleClose}>
      <Alert onClose={handleClose} severity={notification?.type}>
        {notification?.text}
      </Alert>
    </Snackbar>
  );
};

export default Notification;
